// extracted by mini-css-extract-plugin
export default {"main":"PromoCodeEntry_main__xrmG0"};